import React from 'react'
import PropTypes from 'prop-types'
import { NETWORKS } from '../../constants/constants'
import { CrystalIcon, JadeIcon } from '../Icons'

const PriceGroup = ({ label, showIcon, network, value }) => {
    const icon = network === NETWORKS.klaytn.id ? <JadeIcon /> : <CrystalIcon />
    return (
        <div className='price-group'>
            <div className='price-value'>
                {value}{showIcon && icon}
            </div>
            <div className='price-label'>
                {label}
            </div>
        </div>
    )
}

PriceGroup.propTypes = {
    label: PropTypes.element,
    showIcon: PropTypes.bool,
    network: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

PriceGroup.defaultProps = {
}

export default PriceGroup
